export { default as Artist } from "./Artist";
export { default as ContactUs } from "./ContactUs";
export { default as Home } from "./Home";



// WEBPACK FOOTER //
// ./src/pages/index.js